import { render, staticRenderFns } from "./ChannelPart6.vue?vue&type=template&id=68e3f16e&scoped=true&"
import script from "./ChannelPart6.vue?vue&type=script&lang=js&"
export * from "./ChannelPart6.vue?vue&type=script&lang=js&"
import style0 from "./ChannelPart6.vue?vue&type=style&index=0&id=68e3f16e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e3f16e",
  null
  
)

export default component.exports